/* eslint-disable angular/controller-as-vm */
/*********************************************************
 *                  Disruptions Ctrl
 *
 ********************************************************/

"use strict";

angular
	.module("exploitation")
	.controller("EitiDisruptionsEditCtrl", ["$scope",
		"$location",
		"Utils",
		"disruption",
		"mode",
		"$uibModal",
		"EitiDisruptionsService",
		"$controller",
		"toastr",
		"ExploitationService",
		"OkinaLeafletService", function(
		$scope,
		$location,
		Utils,
		disruption,
		mode,
		$uibModal,
		EitiDisruptionsService,
		$controller,
		toastr,
		ExploitationService,
		OkinaLeafletService
	) {
		// just to reuse delete modal functions
		$controller("EitiDisruptionsCtrl", { $scope: $scope, disruptions: [] });

		/************************************************************************************************************
		 *  SETUP
		 *************************************************************************************************************/

		$scope.data = {
			disruption: disruption.data,
			mode: mode,
			isStartDateDisabled: true,
			isEndDateDisabled: true,
			shouldKeepImage: true,
			map: {},
			mapFeatures: {},
			stopPoints: [],
			severity: "UNKNOWN",
			effect: "UNKNOWN"
		};



		//Réglage du calendrier
		$scope.publicationCalendar = {
			opened: {
				start: false,
				end: false
			},
			dateFormat: "dd/MM/yyyy-HH:mm",
			dateOptions: {},
			open: function($event, which) {
				$event.preventDefault();
				$event.stopPropagation();
				$scope.publicationCalendar.opened[which] = true;
			}
		};

		$scope.calendar = {
			opened: {
				start: false,
				end: false
			},
			dateFormat: "dd/MM/yyyy-HH:mm",
			dateOptions: {},
			open: function($event, which) {
				$event.preventDefault();
				$event.stopPropagation();
				$scope.calendar.opened[which] = true;
			}
		};

		$scope.data.disruptionType = "LINE";
		$scope.data.disruptionTypes = [
			{ key: "NETWORK", value: "Réseau" },
			{ key: "LINE", value: "Ligne" },
			{ key: "ROUTE", value: "Itinéraire" },
			{ key: "COURSE", value: "Course" },
			{ key: "STOP_AREA", value: "Point d'arrêt" }
		];


		$scope.data.severityTypes = [
			{ key: "UNKNOWN", value: "Inconnue" },
			{ key: "VERY_SLIGHT", value: "Très légère" },
			{ key: "SLIGHT", value: "Légère" },
			{ key: "NORMAL", value: "Normale" },
			{ key: "SEVERE", value: "Grave" },
			{ key: "VERY_SEVERE", value: "Très grave" },
			{ key: "NO_IMPACT", value: "Pas d'impact" },
			{ key: "UNDEFINED", value: "Non définie" }
		];

		$scope.data.effectsConditions = [
			{ key: "UNKNOWN", value: "Inconnu" },
			{ key: "ALTERED", value: "Altéré" },
			{ key: "CANCELLED", value: "Annulé" },
			{ key: "DELAYED", value: "Retardé" },
			{ key: "DIVERTED", value: "Détourné" },
			{ key: "NO_SERVICE", value: "Pas de service" },
			{ key: "DISRUPTED", value: "Perturbé" },
			{ key: "ADDITIONAL_SERVICE", value: "Service additionnel" },
			{ key: "SPECIAL_SERVICE", value: "Service spécial" },
			{ key: "ON_TIME", value: "A l'heure" },
			{ key: "NORMAL_SERVICE", value: "Service normal" },
			{ key: "INTERMITTENT_SERVICE", value: "Service intermittent" },
			{ key: "SHORT_FORMED_SERVICE", value: "Service en formation courte" },
			{ key: "FULL_LENGTH_SERVICE", value: "Service complet" },
			{ key: "EXTENDED_SERVICE", value: "Service étendu" },
			{ key: "SPLITTING_TRAIN", value: "Train de fractionnement" },
			{ key: "REPLACEMENT_TRANSPORT", value: "Transport de remplacement" },
			{ key: "ARRIVES_EARLY", value: "Arrive tôt" },
			{ key: "SHUTTLE_SERVICE", value: "Service de navette" },
			{ key: "REPLACEMENT_SERVICE", value: "Service de remplacement" },
			{ key: "UNDEFINED_SERVICE_INFORMATION", value: "Information de service indéfinie" }
		];


		$scope.data.disruptionCategories = [
			{ key: "MiscellaneousReason", value: "Raison diverse" },
			{ key: "EquipmentReason", value: "Equipement" },
			{ key: "PersonnelReason", value: "Personnel" },
			{ key: "EnvironmentReason", value: "Environnement" }
		];



		$scope.data.miscellaneousSubCategories = [
			{ key: "UNKNOWN", value: "Raison inconnue" },
			{ key: "UNDEFINED_PROBLEM", value: "Autre cause" },
			{ key: "DEMONSTRATION", value: "Manifestation" },
			{ key: "ACCIDENT", value: "Accident" },
			{ key: "HOLIDAY", value: "Fêtes" },
			{ key: "POLICE_ACTIVITY", value: "Intervention policière" },
			{ key: "INCIDENT", value: "Urgence médicale" }
		];

		$scope.data.equipmentSubCategories = [
			{ key: "TECHNICAL_PROBLEM", value: "Problème technique" },
			{ key: "MAINTENANCE_WORK", value: "Entretien" },
			{ key: "CONSTRUCTION_WORK", value: "Travaux" }
		];

		$scope.data.environmentSubCategories = [
			{ key: "UNDEFINED_ENVIRONMENTAL_PROBLEM", value: "Météo" }
		];

		$scope.data.personnelSubCategories = [
			{ key: "INDUSTRIAL_ACTION", value: "Grève" }
		];

		$scope.data.diffusionType = "DIFFUSING";
		$scope.data.diffusionTypes = [
			{ key: "DIFFUSED", value: "diffusée" },
			{ key: "DIFFUSING", value: "en attente de diffusion" }
		];

		$scope.data.disruptionSubCategory = "UNKNOWN";


		$scope.nbAffectedElements = 0;
		$scope.selectedStopArea = undefined;

		// détermine si l'utilisateur a effectué une modification sur les éléments impactés
		$scope.affectedElementsUpdated = false;

		var closeModal;

		/************************************************************************************************************
		 *  $scope functions
		 *************************************************************************************************************/

		/**
		 * Saves the disruption
		 * @param apiEdit Disruption creation/edition function to call
		 * @param onSuccess Success callback
		 */
		$scope.editDisruption = function(apiEdit, onSuccess) {
			apiEdit()
				.then((response) => {
					toastr.success("", "Perturbation enregistrée");
					if (onSuccess) {
						onSuccess(response.data);
					}
				})
				.catch((error) => {
					const data = error.data;
					let errorMessage =
						"Problème lors de l'enregistrement de la perturbation. ";
					if (data && data.message) {
						errorMessage += data.message;
					}
					toastr.error(errorMessage, "Erreur");
				});
		};

		/**
		 * Sends the disruption form
		 */
		$scope.post = function() {

			if ($scope.data.disruption.endDateTime !== null && $scope.data.disruption.startDateTime > $scope.data.disruption.endDateTime){
				toastr.error("La date de début doit être avant la date de fin",	"Saisie incorrecte"	);
				return;
			}

			if ($scope.data.disruption.publicationStartDateTime > $scope.data.disruption.publicationEndDateTime){
				toastr.error("La date de début de la période de publication doit être avant la date de fin",	"Saisie incorrecte"	);
				return;
			}


			$scope.syncAffectedElements();

			delete $scope.data.disruption.organization;

			$scope.data.disruption.category = $scope.data.disruptionCategory;
			$scope.data.disruption.reason = $scope.data.disruptionSubCategory;


			$scope.data.disruption.periods = $scope.data.effectivePeriods;
			$scope.data.disruption.severity = $scope.data.severity;
			$scope.data.disruption.effect = $scope.data.effect;
			$scope.data.disruption.diffusion = $scope.data.diffusionType;



			if ($scope.isNew()) {
				$scope.editDisruption(
					() =>
						EitiDisruptionsService.addDisruption(
							$scope.data.disruption,
							$scope.data.importFile,
							$scope.data.shouldKeepImage

						),
					() => $location.path("/e-iti/perturbations")
				);
			} else {
				delete $scope.data.disruption.imgFileName;
				delete $scope.data.disruption.imgFileBinary;

				$scope.editDisruption(
					() => EitiDisruptionsService.edit($scope.data.disruption,$scope.data.importFile, $scope.data.shouldKeepImage ),
					data => {
						$scope.data.disruption = data;
						$scope.syncAffectedElements(); // we need to sync affectedElements array ref with the newly instanciated disruption affected elements array
						$location.path("/e-iti/perturbations");
					}
				);
			}
		};


		/**
		 * Checks if the current disruption is closable
		 */
		$scope.isClosable = function() {
			return (
				$scope.data.disruption.periods !== undefined &&
				$scope.data.disruption.periods.length > 0
			);
		};

		$scope.openCloseModal = function() {
			closeModal = Utils.openModal($uibModal, "close.html", $scope);
		};

		/**
		 * Updates the end date time to current date and updates the disruption
		 */
		$scope.closeDisruption = function() {
			$scope.data.disruption.endDateTime = new Date();
			$scope.data.effectivePeriods = [];
			let closePeriod = {};
			closePeriod.startDate = $scope.data.disruption.endDateTime.getTime();
			closePeriod.endDate = $scope.data.disruption.endDateTime.getTime();
			$scope.data.effectivePeriods.push(closePeriod);
			$scope.data.disruption.periods = $scope.data.effectivePeriods;

			EitiDisruptionsService.edit($scope.data.disruption)
				.then(() => {
					toastr.success("", "Perturbation cloturée");
					EitiDisruptionsService.getAll().then((response) => {
						$scope.data.disruptions = response.data;
						closeModal.close();
						$location.url("e-iti/perturbations");
					});
				})
				.catch((error) => {
					toastr.error(
						error.data.message,
						"Problème lors de la cloture de la perturbation"
					);
				});
		};

		/**
		 * Adds an element to the elements affected by this disruption
		 */
		$scope.addElement = function() {
			var elementToAdd = $scope.toValidJson($scope.selectedElement());
			if (
				elementToAdd &&
				$scope.data.affectedElements &&
				!$scope.findById($scope.data.affectedElements, elementToAdd.id)
			) {
				$scope.data.affectedElements.push(elementToAdd);
				$scope.affectedElementsUpdated = true;


				switch ($scope.data.disruptionType) {
					case "NETWORK":
						$scope.data.affectedNetworks.push(elementToAdd);
						break;
					case "LINE":
						$scope.data.affectedLines.push(elementToAdd);
						break;
					case "ROUTE":
						$scope.data.affectedJourneyPatterns.push(elementToAdd);
						break;
					case "COURSE":
						$scope.data.affectedVehicleJourneys.push(elementToAdd);
						break;
					case "STOP_AREA":
						$scope.data.affectedStopAreas.push(elementToAdd);
						break;
				}
			}

			return false;
		};

		/**
		 * Adds a period to the effective periods
		 */
		$scope.addPeriod = function() {

			let start = $scope.data.disruption.startDateTime;
			let end = $scope.data.disruption.endDateTime;

			if (start === undefined ){
				return;
			}

			let newPeriod = {};
			newPeriod.startDate = start.getTime();

			if (end !== undefined){
				newPeriod.endDate = end.getTime();
			}

			$scope.data.effectivePeriods.push(newPeriod);
			return false;
		};

		// Maps an element to its basic version (id + name),
		// to prevent json conversion errors on the backend side (caused by malformed/incomplete objects)
		$scope.toValidJson = function(element) {
			let name = element.name ? element.name : element.public_name;

			if (element.route != null && element.route != undefined){

				let route = element.route;
				if (route.line != null && route.line != undefined){
					let line = route.line;
					if (line.network != null && line.network != undefined){
						name = line.network.name + "/" + line.name + "/" + name;
					}
				}
			}else if (element.line != null && element.line != undefined){
				let line = element.line;
				if (line.network != null && line.network != undefined){
					name = line.network.name + "/" + line.name + "/" + name;
				}
			} else if ($scope.data.disruptionType === "LINE" && element.number != null){
				return { id: element.id, name: name, number: element.number, objectId: element.object_id};
			}
			return { id: element.id, name: name };
		};

		/**
		 * Returns the currently selected element
		 */
		$scope.selectedElement = function() {
			var elementToAdd = undefined;
			switch ($scope.data.disruptionType) {
				case "NETWORK":
					elementToAdd = $scope.findById(
						$scope.data.networks,
						$scope.data.currentNetwork
					);
					break;
				case "LINE":
					elementToAdd = $scope.findById(
						$scope.data.lines,
						$scope.data.currentLine
					);
					break;
				case "ROUTE":

					var currNetwork = $scope.findById(
						$scope.data.networks,
						$scope.data.currentNetwork
					);

					var currLine = $scope.findById(
						$scope.data.lines,
						$scope.data.currentLine
					);

					currLine.network = currNetwork;


					elementToAdd = $scope.findById(
						$scope.data.routes,
						$scope.data.currentRoute
					);

					elementToAdd.line = currLine;

					break;
				case "COURSE":
					elementToAdd = $scope.findById(
						$scope.data.courses,
						$scope.data.currentCourse
					);
					break;
				case "STOP_AREA":
					elementToAdd = $scope.selectedStopArea;
					break;
			}
			return elementToAdd;
		};

		/**
		 * Removes a topoly element from the list of affected elements
		 */
		$scope.removeElement = function(elementToRemove) {
			if (elementToRemove && $scope.data.affectedElements) {
				var indexToRemove = $scope.data.affectedElements.indexOf(
					elementToRemove
				);
				$scope.data.affectedElements.splice(indexToRemove, 1);
				$scope.affectedElementsUpdated = true;

				removeElementFromList($scope.data.affectedNetworks, elementToRemove);
				removeElementFromList($scope.data.affectedLines, elementToRemove);
				removeElementFromList($scope.data.affectedVehicleJourneys, elementToRemove);
				removeElementFromList($scope.data.affectedJourneyPatterns, elementToRemove);
				removeElementFromList($scope.data.affectedStopAreas, elementToRemove);
			}
			return false;
		};

		function removeElementFromList(list, elementToRemove) {
			var indexToRemove = list.indexOf(
				elementToRemove
			);
			if (indexToRemove === -1){
				return;
			}

			list.splice(indexToRemove, 1);
		}


		/**
		 * Removes a topoly element from the list of affected elements
		 */
		$scope.removePeriod = function(periodToRemove) {
			if (periodToRemove && $scope.data.effectivePeriods) {
				var indexToRemove = $scope.data.effectivePeriods.indexOf(
					periodToRemove
				);
				$scope.data.effectivePeriods.splice(indexToRemove, 1);
			}
			return false;
		};

		/**
		 * Return the display name of the element
		 * @param element
		 * @return
		 * 			The display name
		 */
		$scope.getAffectedElementDisplayName = function(element) {
			if(element.number != null){
				return element.number + " - " + element.name;
			}
			return element.name;

		}

		/**
		 * Return the display of the period : startDate - endDate
		 * @param element
		 * @return
		 * 			The display text
		 */
		$scope.getPeriodDisplayText = function(period) {
			let startDate = new Date(period.startDate).toLocaleString();
			let endDate;

			if(period.endDate !== null && period.endDate !== undefined){
				endDate =  " - " + new Date(period.endDate).toLocaleString();
			}
			else {
				endDate = "";
			}

			return startDate + endDate;
		}

		$scope.removeImage = function() {
			delete $scope.data.imgFileName;
			delete $scope.data.imgFileBinary;
			delete $scope.data.importFile;
			delete $scope.data.shouldKeepImage;
		}





		$scope.changeDisruptionCategory = function() {

			switch ($scope.data.disruptionCategory) {
				case "EquipmentReason":
					$scope.data.disruptionSubCategories = $scope.data.equipmentSubCategories;
					break;
				case "PersonnelReason":
					$scope.data.disruptionSubCategories = $scope.data.personnelSubCategories;
					break;
				case "EnvironmentReason":
					$scope.data.disruptionSubCategories = $scope.data.environmentSubCategories;
					break;
				case "MiscellaneousReason":
					$scope.data.disruptionSubCategories = $scope.data.miscellaneousSubCategories;
					break;
				default:
					$scope.data.disruptionSubCategories = $scope.data.miscellaneousSubCategories;
					break;
			}

			$scope.data.disruptionSubCategory = $scope.data.disruptionSubCategories[0].key;
		}

		/**
		 * Returns the elements affected by this disruption
		 */
		$scope.changeDisruptionType = function(type) {
			 if ($scope.data.disruption) {

				 if ($scope.data.disruption.networks.length > 0){
					 $scope.data.affectedElements = addValuesToArray( $scope.data.affectedElements, $scope.data.disruption.networks);
					 $scope.data.affectedNetworks = addValuesToArray( $scope.data.affectedNetworks, $scope.data.disruption.networks);
				 }

				 if ($scope.data.disruption.lines.length > 0){
					 $scope.data.affectedElements = addValuesToArray( $scope.data.affectedElements, $scope.data.disruption.lines);
					 $scope.data.affectedLines = addValuesToArray( $scope.data.affectedLines, $scope.data.disruption.lines);
				 }

				 if ($scope.data.disruption.journeys.length > 0){
					 $scope.data.affectedElements = addValuesToArray( $scope.data.affectedElements, $scope.data.disruption.journeys);
					 $scope.data.affectedJourneyPatterns = addValuesToArray( $scope.data.affectedJourneyPatterns, $scope.data.disruption.journeys);
				 }

				 if ($scope.data.disruption.courses.length > 0){
					 $scope.data.affectedElements = addValuesToArray( $scope.data.affectedElements, $scope.data.disruption.courses);
					 $scope.data.affectedVehicleJourneys = addValuesToArray( $scope.data.affectedVehicleJourneys, $scope.data.disruption.courses);
				 }

				 if ($scope.data.disruption.stopAreas.length > 0){
					 $scope.data.affectedElements = addValuesToArray( $scope.data.affectedElements, $scope.data.disruption.stopAreas);
					 $scope.data.affectedStopAreas = addValuesToArray( $scope.data.affectedStopAreas, $scope.data.disruption.stopAreas);
				 }

			 }

			$scope.nbAffectedElements = $scope.data.affectedElements.length;
		};

		/**
		 * Clears some data to avoid problems on json conversion
		 */
		$scope.clearElementsBeforeSend = function(courseList) {
			let clearedList = [];
			courseList.forEach(e =>{

					let clearedElement = e;
					delete clearedElement.name;
					clearedList.push(clearedElement);
			});
			return clearedList;
		};

		$scope.syncAffectedElements = function() {

			$scope.data.disruption.networks = $scope.data.affectedNetworks;
			$scope.data.disruption.lines = $scope.data.affectedLines;
			$scope.data.disruption.journeys = $scope.data.affectedJourneyPatterns;
			$scope.data.disruption.courses = $scope.clearElementsBeforeSend($scope.data.affectedVehicleJourneys);
			$scope.data.disruption.stopAreas = $scope.data.affectedStopAreas;


		};

		/**
		 * Callback for stop area selection
		 */
		$scope.stopAreaSelected = function(stopArea) {
			$scope.selectedStopArea = stopArea;
			$scope.returnStopPointSearch(stopArea);
		};

		$scope.findById = function(elements, id) {
			return elements.filter(item => item.id === id)[0];
		};

		/**
		 * Tests if the current disruption is a new one
		 */
		$scope.isNew = function() {
			return $scope.data.mode === "new";
		};

		/**
		 * Tests if a network has to be selected for this type of disruption
		 */
		$scope.networkHasToBeSelected = function() {
			return "STOP_AREA" !== $scope.data.disruptionType;
		};

		/**
		 * Tests if a line has to be selected for this type of disruption
		 */
		$scope.lineHasToBeSelected = function() {
			return (
				["NETWORK", "STOP_AREA"].indexOf($scope.data.disruptionType) ==
				-1
			);
		};

		/**
		 * Tests if a route has to be selected for this type of disruption
		 */
		$scope.journeyHasToBeSelected = function() {
			return (
				["NETWORK", "LINE", "STOP_AREA"].indexOf(
					$scope.data.disruptionType
				) === -1
			);
		};

		/**
		 * Tests if a course has to be selected for this type of disruption
		 */
		$scope.courseHasToBeSelected = function() {
			return (
				["NETWORK", "LINE", "ROUTE", "STOP_AREA"].indexOf(
					$scope.data.disruptionType
				) === -1
			);
		};

		/**
		 * Tests if a stop area has to be selected for this type of disruption
		 */
		$scope.stopAreaHasToBeSelected = function() {
			return "STOP_AREA" == $scope.data.disruptionType;
		};

		$scope.data.periods = [
			{
				name: "A partir de maintenant",
				set: function() {
					$scope.fromNowOn();
				}
			},
			{
				name: "Pendant une heure",
				set: function() {
					$scope.anHourStartingFromNow();
				}
			},
			{
				name: "Aujourd'hui",
				set: function() {
					$scope.today();
				}
			},
			{
				name: "Demain",
				set: function() {
					$scope.tomorrow();
				}
			},
			{
				name: "A définir",
				set: function() {
					$scope.data.isStartDateDisabled = false;
					$scope.data.isEndDateDisabled = false;
					$scope.setDisruptionPeriod();
				}
			}
		];



		// Sets the current disruption period as starting now
		$scope.fromNowOn = function() {
			$scope.data.isStartDateDisabled = true;
			$scope.data.isEndDateDisabled = false;
			$scope.setDisruptionPeriod(new Date());
		};
		// Sets the current disruption period to the current hour
		$scope.anHourStartingFromNow = function() {
			$scope.data.isStartDateDisabled = true;
			$scope.data.isEndDateDisabled = true;
			const now = new Date();
			const anHourFromNow = new Date(now);
			anHourFromNow.setHours(now.getHours() + 1);
			$scope.setDisruptionPeriod(now, anHourFromNow);
		};
		// Sets the current disruption period as today
		$scope.today = function() {
			$scope.data.isStartDateDisabled = true;
			$scope.data.isEndDateDisabled = true;
			const startToday = new Date();
			const endToday = new Date();
			startToday.setHours(0, 0, 0, 0);
			endToday.setHours(23,59, 59);
			$scope.setDisruptionPeriod(startToday, endToday);
		};

		// Sets the current disruption period as tomorrow
		$scope.tomorrow = function() {
			$scope.data.isStartDateDisabled = true;
			$scope.data.isEndDateDisabled = true;
			const startTomorrow = $scope.dayAfter(new Date());
			const endTomorrow = $scope.dayAfter(new Date());
			startTomorrow.setHours(0, 0, 0, 0);
			endTomorrow.setHours(23, 59, 59);
			$scope.setDisruptionPeriod(startTomorrow, endTomorrow);
		};
		// Returns the date representing the day after the specified date
		$scope.dayAfter = function(date) {
			$scope.data.isStartDateDisabled = true;
			$scope.data.isEndDateDisabled = true;
			const dayAfter = new Date(date);
			dayAfter.setDate(date.getDate() + 1);
			return dayAfter;
		};

		// Sets the current disruption period
		$scope.setDisruptionPeriod = function(start, end) {

			$scope.data.disruption.startDateTime = start;
			$scope.data.disruption.endDateTime = end;
		};

		/**
		 * Read each values of arrayOfValuesToAdd and add them to finalArray if there are not already included
		 *
		 * @param finalArray
		 * 	the final array that will contain existing values + newly added values
		 * @param arrayOfValuesToAdd
		 * The array containing the values to add.
		 * @returns {Array} The `finalArray` updated with the added values.
		 */
		function addValuesToArray(finalArray, arrayOfValuesToAdd) {
			for (let i = 0; i < arrayOfValuesToAdd.length; i++) {
				let valeur = arrayOfValuesToAdd[i];
				if (!finalArray.includes(valeur)) {
					finalArray.push(valeur);
				}
			}
			return finalArray;
		}
		/**
		 * Builds a new empty disruption
		 */
		this.buildDisruption = function() {
			return {
				lines: [],
				networks: [],
				journeys: [],
				courses: [],
				stopAreas: []
			};
		};

		/**
		 * Initializes disruption type
		 */
		this.initDiffusionType = function(disruption) {
			var diffusionType = "DIFFUSING";
			if ($scope.data.disruption.diffusion === "DIFFUSING") {
				diffusionType = "DIFFUSING";
			} else if ($scope.data.disruption.diffusion === "DIFFUSED") {
				diffusionType = "DIFFUSED";
			}
			return diffusionType;
		}

		/**
		 * Initializes disruption type
		 */
		this.initType = function(disruption) {
			var disruptionType = "LINE";
			if (
				$scope.data.disruption.networks !== undefined &&
				$scope.data.disruption.networks.length > 0
			) {
				disruptionType = "NETWORK";
			} else if (
				$scope.data.disruption.lines !== undefined &&
				$scope.data.disruption.lines.length > 0
			) {
				disruptionType = "LINE";
			} else if (
				$scope.data.disruption.journeys !== undefined &&
				$scope.data.disruption.journeys.length > 0
			) {
				disruptionType = "ROUTE";
			} else if (
				$scope.data.disruption.courses !== undefined &&
				$scope.data.disruption.courses.length > 0
			) {
				disruptionType = "COURSE";
			} else if (
				$scope.data.disruption.stopAreas !== undefined &&
				$scope.data.disruption.stopAreas.length > 0
			) {
				disruptionType = "STOP_AREA";
			}
			return disruptionType;
		};

		/**
		 * Initializes controller data
		 */
		this.init = function($scope) {
			if ($scope.isNew()) {
				$scope.data.disruption = this.buildDisruption();
			}
			$scope.data.disruptionType = this.initType($scope.data.disruption);
			$scope.data.diffusionType = this.initDiffusionType($scope.data.disruption);
			$scope.data.affectedElements = [];
			$scope.data.affectedNetworks = [];
			$scope.data.affectedLines = [];
			$scope.data.affectedVehicleJourneys = [];
			$scope.data.affectedJourneyPatterns = [];
			$scope.data.affectedStopAreas = [];
			$scope.data.effectivePeriods = [];
			$scope.data.disruption.startDateTime = null;
			$scope.data.disruption.endDateTime = null;
			if ($scope.data.disruption.periods !== undefined){
				$scope.data.effectivePeriods = $scope.data.disruption.periods;
			}

			$scope.changeDisruptionType($scope.data.disruptionType);

			if ( $scope.data.disruption !== null &&  $scope.data.disruption.imgFileName != null){
				$scope.data.imgFileName = $scope.data.disruption.imgFileName;
			}

			if ( $scope.data.disruption !== null &&  $scope.data.disruption.imgFileBinary != null){
				$scope.data.imgFileBinary = $scope.data.disruption.imgFileBinary;
			}
		};


		let linkToImageImport;

		$scope.importImage = () => {
			$scope.data.previousImportFile = $scope.data.importFile;
			linkToImageImport = Utils.openModal($uibModal, "import-img.html", $scope, "lg");

		};

		$scope.cancelAndClose = () => {
			$scope.data.importFile = $scope.data.previousImportFile;
			linkToImageImport.close();
		}

		$scope.formatBase64Data = (rawData) => {
			if (rawData != null && rawData.startsWith("data:image/")){
				return rawData;
			}

			return "data:image/JPEG;base64,"+ rawData;

		}

		$scope.validateAndClose = () => {
			if ($scope.data.importFile.size > 500000){
				toastr.error("Taille de fichier supérieure à 500 ko", "Erreur");
				return;
			}

			if ($scope.data.importFile.type !== "image/png" && $scope.data.importFile.type !== "image/jpeg"){
				toastr.error("Seuls les fichiers png et jpg sont autorisés", "Erreur");
				return;
			}

			$scope.data.imgFileName = $scope.data.importFile.name;
			$scope.data.shouldKeepImage = true;



			getBase64($scope.data.importFile);
			linkToImageImport.close();
		}

		function getBase64(file) {
			var reader = new FileReader();
			reader.readAsDataURL(file);
			reader.onload = function () {
				$scope.$apply(function () {
					$scope.data.imgFileBinary = reader.result;
				});
			};
		}


		if ($scope.data.disruption && $scope.data.disruption.category){
			$scope.data.disruptionCategory = $scope.data.disruption.category;
			$scope.changeDisruptionCategory();

			$scope.data.disruptionSubCategory = $scope.data.disruption.reason;
		}else{
			$scope.data.disruptionCategory = "MiscellaneousReason";
			$scope.changeDisruptionCategory();
		}

		if ($scope.data.disruption){
			$scope.data.severity = $scope.data.disruption.severity;
			$scope.data.effect = $scope.data.disruption.effect;
		}


		/*
			fonctionnement map
 		*/

		$scope.LeafletService = OkinaLeafletService;
		initMap();

		/**
		 * Restful navigation.
		 */
		function initPoint()
		{
			if ($routeParams.stopPointId) {

				let selectedPoint = $scope.data.displayedStopPoints.find(point=> point.id === parseInt($routeParams.stopPointId));
				ExploitationService.setCurrentStopPoint(selectedPoint);
				setSelectedStopPointFromId( parseInt($routeParams.stopPointId));

				OkinaLeafletService.setCenter({
					lng: selectedPoint.longitude,
					lat: selectedPoint.latitude,
					zoom: 15
				});
			}
		}

		/******************
		 * SCOPE FUNCTIONS
		 ******************/

		/*
		 * Retourne les infos et affiche la map pour le stop point selectionné.
		 */
			$scope.returnStopPointSearch = function (stopPoint) {
				setSelectedStopPointFromId(stopPoint.id);
				$scope.data.stopPointsSearch = {};

				// on zoom sur le point d'arrêt sélectionné
				OkinaLeafletService.setCenter({
					lat: stopPoint.latitude,
					lng: stopPoint.longitude,
					zoom: 20
				});
			};

		/******************
		 * UTILS
		 ******************/

		function initMap(zoomTo) {
			OkinaLeafletService.init("map",  {markerLayerCluster: true});

			OkinaLeafletService.setCenter({
				lat:  zoomTo ? zoomTo.lat : 47.070659,
				lng:  zoomTo ? zoomTo.lng : 1.6146023,
				zoom: zoomTo ? zoomTo.zoom : 6
			});

			loadMarkers();
		}

		/**
		 * Charge les markers pour les stoppoints
		 */
		function loadMarkers() {
			ExploitationService.getAllOkinaStopPointsForMap()
				.then((response) => {
					const stopPoints = response.data;
					$scope.data.displayedStopPoints = stopPoints;

					stopPoints
						.map(sp => {
							const color = $scope.data.currentStopPoint != null && $scope.data.currentStopPoint.id === sp.id ? "red" : "blue";
							return formatMarkerFromStopPointShow(sp, color);
						})
						.forEach(marker => {
							OkinaLeafletService.createMarkerWithName(marker.id, marker);
						});


					initPoint();

				})
				.finally(() => {
					if ($scope.data.currentStopPoint != null && $scope.data.currentStopPoint.id != null) {
						setSelectedStopPointFromId($scope.data.currentStopPoint.id);
					}
				});
		}

		/**
		 * @param sp stop-point
		 * @param color
		 * @returns {{lng: *, icon: {number: *, markerColor: *, prefix: null, icon: string, type: string}, id: *, message: string, lat: *}}
		 */
		function formatMarkerFromStopPointShow(sp, color) {
			return {
				lat: sp.latitude,
				lng: sp.longitude,
				id: sp.id,
				icon: {
					type: "awesomeMarker",
					icon: "circle",
					prefix: "fa",
					markerColor: color,
				},
				message: null,
				onClick: (e) => {
					const clickedMarker = e.target;
					$scope.data.currentStopPoint = clickedMarker.options;
					const stopPoint = $scope.data.displayedStopPoints.find(sp => sp.id === clickedMarker.options.id);
					$scope.data.pointToDisplay = stopPoint !== undefined ? stopPoint : clickedMarker.options;
					$scope.selectedStopArea = $scope.data.pointToDisplay;
					setSelectedStopPointFromId(clickedMarker.options.id);
				}
			};
		}

		/**
		 * Sélectionne le stopPoint sur lequel l'utilisateur vient de cliquer
		 * Passe l'icone en rouge et désélectionne tous les autres markers de la view
		 * Charge le contenu de la popup du marker à afficher avec la liste des network lines
		 * On ne permet pas de sélectionner un nouveau marker si on est en mode édition ou création
		 *
		 * @param event
		 */

		$scope.setSelectedStop = async function (stopPointId) {
			await setSelectedStopPointFromId(stopPointId);
		};

		/**
		 * Sélectionne le stopPoint sur lequel l'utilisateur vient de cliquer
		 * Passe l'icone en rouge et désélectionne tous les autres markers de la view
		 * Charge le contenu de la popup du marker à afficher avec la liste des network lines
		 * On ne permet pas de sélectionner un nouveau marker si on est en mode édition ou création

		 * @param stopPointId
		 */
		function setSelectedStopPointFromId(stopPointId) {
			$scope.data.editMode = false;

			// marker icon
			let marker = OkinaLeafletService.getMarkerWithName(stopPointId);

			// reset all markers icons
			OkinaLeafletService.unselectAllMarkers();

			if (marker != null) {
				marker.setIcon(OkinaLeafletService.getIcon(true));
			}
		}


		/**
		 * Used to check if action buttons must be displayed onto a table line.
		 * @param stopPoint
		 * @returns {boolean}
		 */
		$scope.isStopPointSelected = function (stopPoint) {
			if (ExploitationService.getCurrentStopPoint()) {
				return stopPoint.id === ExploitationService.getCurrentStopPoint().id;
			} else {
				return false;
			}
		};
	this.init($scope);
	}]);
